// @flow
import { HEADER_HEIGHT } from 'app/constants'

type PageMeta = {
  title: string,
  desc?: string,
  scrollTo: string,
  scrollBehavior: string,
  focusTitle: boolean,
  gaTrack: boolean,
}

/**
 * Manually update page title and desc, focus and scroll to the top of the page
 * - for SPA routes, will focus #spa-page-title or fall back to #app
 * - will smooth scroll to top of page
 * @param title
 * @param desc
 * @param scrollTo
 * @param scrollBehavior
 * @param focusTitle
 * @param gaTrack
 */
export const spaMetaUpdateAndTrack = ({
  title = '',
  desc,
  scrollTo = 'top',
  scrollBehavior = 'instant', // smooth and auto supported
  focusTitle = true,
  gaTrack = false,
}: PageMeta = {}) => {
  /* TITLE TAG UPDATES */
  const titleEl = document.querySelector('head > title')

  if (title && titleEl) {
    titleEl.innerHTML = title
  }
  // end title

  /* SCROLL TO TOP - DEFAULT */
  // test for native smooth scroll options
  // eslint-disable-next-line
  const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style

  if (scrollTo === 'top') {
    // delaying so vue component can be mounted, this is hacky but do not have
    // access to lifecycle hooks in this function
    setTimeout(() => {
      if (supportsNativeSmoothScroll) {
        window.scrollTo({ top: 0, behavior: scrollBehavior })
      } else {
        window.scrollTo(0, 0)
      }
    }, 25)
  }
  // end scroll to top

  // scroll to query selector element
  if (scrollTo && scrollTo !== 'top') {
    // delaying so vue component can be mounted, this is hacky but do not have
    // access to lifecycle hooks in this function
    setTimeout(() => {
      const scrollEl = document.querySelector(`${scrollTo}`)

      if (scrollEl) {
        const scrollToY = scrollEl.offsetTop - HEADER_HEIGHT

        if (supportsNativeSmoothScroll) {
          window.scrollTo({ top: scrollToY, behavior: scrollBehavior })
        } else {
          window.scrollTo(0, scrollToY)
        }
      }
    }, 25)
  }

  // focus primary title
  if (focusTitle) {
    // delayed focus to allow for rendering
    setTimeout(() => {
      const focusEl = document.querySelector('#spa-title')

      if (focusEl) {
        // also focus, but not keyboard tab
        focusEl.style.outline = 'none'
        focusEl.setAttribute('tabindex', '-1')
        focusEl.focus()
      }
    }, 250)
  }

  // manually push to GA
  // let XHRs settle before sending
  setTimeout(() => {
    if (gaTrack && window.ga) {
      window.ga('set', 'page', `${window.location.pathname}${window.location.search}`)
      window.ga('send', 'pageview')
    }
  }, 150)
}
